import { buildTrophies } from '../../logic/trophies'
import { useAllBadges } from '../badges/useAllBadges'
import { useUserBadges } from '../badges/useUserBadges'
import { useChallenge } from '../challenge/useChallenge'
import { useChallengeId } from '../challenge/useChallengeId'
import { useTeamMemberships } from '../membership/useTeamMemberships'
import { useTeam } from '../team/useTeam'
import { useUser } from '../user/useUser'
import { useUserByID } from '../user/useUserByID'

export function useProfileData(userID?: string, teamIdOverride?: string) {
  const { data: viewer, isLoading: viewerLoading } = useUser()
  const isOwn = !userID || userID === viewer?.id
  const { data: otherUser, isLoading: otherLoading } = useUserByID(isOwn ? null : userID)
  const user = isOwn ? viewer : otherUser

  const activeChallengeId = useChallengeId()
  const { data: memberships, isLoading: membershipsLoading } = useTeamMemberships(user?.id)
  const membership = memberships?.find((row) => row.challengeID === activeChallengeId)
  const { data: team, isLoading: teamLoading } = useTeam(teamIdOverride || membership?.teamID || '')
  const challengeId = team?.challengeID ?? activeChallengeId

  const { data: challenge, isLoading: challengeLoading } = useChallenge(challengeId)
  const { data: allBadges = [], isLoading: badgesLoading } = useAllBadges(challengeId)
  const { data: userBadges = [], isLoading: userBadgesLoading } = useUserBadges(
    user?.id ?? '',
    challengeId,
  )

  return {
    user: user ?? null,
    isOwn,
    team: team ?? null,
    challengeName: challenge?.name ?? 'Relentless',
    trophies: buildTrophies(allBadges, userBadges, 'user'),
    isLoading:
      viewerLoading ||
      (!isOwn && otherLoading) ||
      membershipsLoading ||
      teamLoading ||
      challengeLoading ||
      badgesLoading ||
      userBadgesLoading,
  }
}
